import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "imglist"
  }, [_c("a-row", [_c("a-row", [_c("draggable", {
    staticClass: "dragArea",
    attrs: {
      tag: "div",
      list: _vm.value
    }
  }, _vm._l(_vm.value, function (item, i) {
    return _c("div", {
      key: i,
      staticClass: "img-item",
      on: {
        click: function click($event) {
          return _vm.handleImgClick(i);
        }
      }
    }, [_c("YYImage", {
      style: {
        width: "calc(100% - 30px)",
        height: "100px",
        objectFit: "contain"
      },
      attrs: {
        lazy: false,
        fit: "contain",
        src: _vm.imgHost + item.path
      }
    }), _c("a-popconfirm", {
      attrs: {
        title: _vm.$t("com.askDelete"),
        "ok-text": _vm.$t("com.ok"),
        "cancel-text": _vm.$t("com.cancel"),
        placement: "topRight",
        overlayStyle: {
          minWidth: "200px"
        }
      },
      on: {
        confirm: function confirm($event) {
          return _vm.handleConfirmDelete(i);
        }
      }
    }, [_c("a-icon", {
      staticClass: "icon-delete",
      attrs: {
        type: "delete"
      },
      on: {
        click: function click($event) {
          $event.stopPropagation();
        }
      }
    })], 1)], 1);
  }), 0)], 1), _c("a-row", [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleAddImg
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _vm._v(" " + _vm._s(_vm.$t("com.addPic")) + " ")], 1)], 1), _vm.value[_vm.curImgItem] ? _c("FormEditPage", {
    staticClass: "formedit",
    attrs: {
      show: _vm.showSlide,
      title: _vm.$t("com.editPic")
    },
    on: {
      "update:show": function updateShow($event) {
        _vm.showSlide = $event;
      }
    }
  }, [_c("FileUpload", {
    attrs: {
      list: _vm.list
    },
    on: {
      success: _vm.handleUploadSuccess,
      delete: _vm.handleClearImg
    }
  }), typeof _vm.value[_vm.curImgItem].name !== "undefined" ? _c("CardItem", {
    attrs: {
      title: _vm.$t("com.trackName"),
      layout: "vertical"
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 1000
    },
    model: {
      value: _vm.value[_vm.curImgItem].name,
      callback: function callback($$v) {
        _vm.$set(_vm.value[_vm.curImgItem], "name", $$v);
      },
      expression: "value[curImgItem].name"
    }
  })], 1) : _vm._e(), _c("CardItem", {
    attrs: {
      title: _vm.$t("com.link"),
      layout: "vertical"
    }
  }, [_c("a-textarea", {
    attrs: {
      placehoder: _vm.$t("com.picLink"),
      rows: "5"
    },
    model: {
      value: _vm.value[_vm.curImgItem].link,
      callback: function callback($$v) {
        _vm.$set(_vm.value[_vm.curImgItem], "link", $$v);
      },
      expression: "value[curImgItem].link"
    }
  })], 1), _c("a-row", [_c("a-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "dashed"
    },
    on: {
      click: _vm.handleDeleteImg
    }
  }, [_vm._v(_vm._s(_vm.$t("com.deletePic")))])], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };